import BootcampInstanceAssignment from '../api/bootcampInstanceAssignment';
import { applicationSave, applicationFetch, applicationUpdate, applicationFetchAll } from './applicationActions';

export const saveBootcampInstanceAssignment = applicationSave(BootcampInstanceAssignment);
export const fetchBootcampInstanceAssignment = applicationFetch(BootcampInstanceAssignment);
export const updateBootcampInstanceAssignment = applicationUpdate(BootcampInstanceAssignment);
export const fetchBootcampInstanceAssignments = applicationFetchAll(BootcampInstanceAssignment);
